export const NUMBER_RANGE_REDUCER_STATE_ID = 'numberRange';
